import Adjudication from "./Adjudication";

export default Adjudication;
